export default __webpack_public_path__ + "static/media/ey_logo.e0b36f95.png";